import React from 'react';
import { Link } from 'react-router-dom';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import './Footer.css';
import lImg from '../img/looogo.png';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const ScrollToTopLink = ({ to, children, className }) => {
    const handleClick = () => {
      scrollToTop();
    };

    return (
      <Link to={to} className={className} onClick={handleClick}>
        {children}
      </Link>
    );
  };

  return (
    <MDBFooter bgColor="light" className="text-center text-lg-start text-muted custom-footer">
      <section className="">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3">
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">
                <MDBIcon icon="gem" className="me-3" />
                <img src={lImg} alt="Maderas Estufadas del Guadiana" />
              </h6>
              <p></p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Productos</h6>

              <p>
                <ScrollToTopLink to="/es/products" className="text-reset">
                  Beds
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/products" className="text-reset">
                  Coves
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/products" className="text-reset">
                  Casung
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/products" className="text-reset">
                  Stops
                </ScrollToTopLink>
              </p>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Enlaces útiles</h6>
              <p>
                <ScrollToTopLink to="/es/home" className="text-reset">
                  Casa
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/about" className="text-reset">
                  Nosotros
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/products" className="text-reset">
                  Productos
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/contact" className="text-reset">
                  Contacto
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/es/login" className="text-reset">
                  Entrar
                </ScrollToTopLink>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Contacto</h6>
              <p>
                <MDBIcon icon="home" className="me-2" />
                Durango, Durango, MX
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-3" />
                megnasa21@gmail.com
              </p>
              <p>
                <MDBIcon icon="phone" className="me-3" /> +52 618 824 6172
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className="text-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © {new Date().getFullYear()} Copyright © 2024 - Creado por WingWeb
        <ScrollToTopLink className="text-reset fw-bold" to="#!"></ScrollToTopLink>
      </div>
    </MDBFooter>
  );
};

export default Footer;